export default __webpack_public_path__ + "static/media/ic-warning.35d8d203.svg";